import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select } from '@opendate-app/setlist';

const EventTemplateSelect = ({ teamId, value, onChange, id, clearable }) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    axios.get(`/teams/${teamId}/event_templates`).then((response) => {
      setTemplates(response.data.map((t) => ({ value: t.id, label: t.name })));
    });
  }, [teamId]);

  const options = value && !templates.some((t) => t.value === value.value)
    ? [value, ...templates]
    : templates;

  return (
    <Select
      id={id}
      searchable
      clearable={clearable}
      placeholder="Select..."
      options={options}
      value={value ? value.value : null}
      onChange={(next) => onChange(options.find((o) => o.value === next) || null)}
    />
  );
};

EventTemplateSelect.propTypes = {
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.shape({ value: PropTypes.any, label: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  clearable: PropTypes.bool,
};

export default EventTemplateSelect;
